export const SHOPPING_LIST_LAYOUT = "shoppingList";

export const SHOPPING_LIST_CLASSES = {
  hideOnMobile: `${SHOPPING_LIST_LAYOUT}-hideOnMobile`,
  heading: `${SHOPPING_LIST_LAYOUT}-heading`,
  sendButton: `${SHOPPING_LIST_LAYOUT}-sendButton`,
  title: `${SHOPPING_LIST_LAYOUT}-title`,
  notification: `${SHOPPING_LIST_LAYOUT}-notification`,
};

export const STICKY_BUTTON_HEIGHT = "115px";
